import React from 'react';
import PropTypes from 'prop-types';

const Results = ({page, limit = 0, itemCount = 0, totalCount = 0, className, classNameNoResults}) => {
	const pageConst = page ? Number(page) : 1;
	let showing = null;

	if (itemCount > 0) {
		const start = (pageConst * limit) - limit + 1;
		const end = typeof totalCount === 'number'
			? Math.min(start + itemCount - 1, totalCount)
			: start + itemCount - 1;
		const hasTotal = typeof totalCount === 'number';

		showing = (
			<span>
				Showing {start.toLocaleString()}-{end.toLocaleString()}{hasTotal ? ` of ${totalCount.toLocaleString()}` : ''}
			</span>
		);
	} else {
		showing = (<div className={`no-results ${classNameNoResults ? classNameNoResults : ''}`}>Sorry, there are no results.</div>);
	}

	return (
		<div className={className || `Results${itemCount <= 0 ? ' no-results' : ''}`}>
			{showing}
		</div>
	);
};

Results.propTypes = {
    limit: PropTypes.number.isRequired,
        page: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
	totalCount: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.bool,
    ]).isRequired,
	itemCount: PropTypes.number.isRequired,
};

export default Results;